<div class="ride-group" *ngIf="dSS.dienststelle && dSS.modusErweitert">
  <ion-row>
    <ion-col>
      <h3>Leasingrahmenbedingungen</h3>
    </ion-col>
  </ion-row>
</div>
<ng-container *ngIf="dSS.modusErweitert">
  <ion-row>
    <ion-col>
      <ion-list>
        <ion-item lines="inset">
          <ion-select
            label="Leasingdauer"
            interface="popover"
            [(ngModel)]="dSS.leasingDuration"
            (ionChange)="update($event)"

          >
            <ion-select-option
              *ngFor="let option of dSS.ldList"
              [value]="option.value"
            >
              {{ option.display }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
    </ion-col>
  </ion-row>
<ng-container id="ustContainer" *ngIf="dSS.dsCode.toLowerCase() !== 'aok-1223'">
  <ion-row >
    <ion-col>
      <ion-list>
        <ion-item lines="inset">
          <ion-select label="Ist Ihr AG  vorsteuerabzugsberechtigt?"
                      labelPlacement="floating"
                      *ngIf="dSS.bArt !== 0; else beAmtemBlock"
            interface="popover"
            [(ngModel)]="dSS.dienststelle.ustAG"
            (ionChange)="update($event)"
            [disabled]="dSS.dienststelle.disabledUstAg"
          >
            <ion-select-option
              *ngFor="let option of erwJaNeinList"
              [value]="option.value"
            >
              {{ option.display }}
            </ion-select-option>
          </ion-select>
          <ng-template #beAmtemBlock>
            <ion-select
              interface="popover"
              label="Ist Ihr AG  vorsteuerabzugsberechtigt?"
              labelPlacement="floating"
              [(ngModel)]="dSS.dienststelle.ustAGBeamte"
              (ionChange)="update($event)"
              [disabled]="dSS.dienststelle.disabledUstAg"
            >
              <ion-select-option
                *ngFor="let option of erwJaNeinList"
                [value]="option.value"
              >
                {{ option.display }}
              </ion-select-option>
            </ion-select>
          </ng-template>
        </ion-item>
      </ion-list>
    </ion-col>
  </ion-row>
  <ng-container *ngIf="dSS.dienststelle.ustAG === 2">
    <ion-row>
      <ion-col>
        <ion-list>
          <ion-item lines="inset">
            <ion-label>Ab wann?</ion-label>
            <ion-datetime-button
              datetime="datetime"
              color="green"
            ></ion-datetime-button>
            <ion-modal [keepContentsMounted]="true">
              <ng-template>
                <ion-modal [keepContentsMounted]="true">
                  <ng-template>
                    <ion-datetime
                    id="datetime"
                    datetime
                    presentation="month-year"
                    min="{{ minDate }}"
                    max="{{ maxDate }}"
                    [showDefaultButtons]="true"
                    [ngModel]="this.dSS.selectedDate?.toISOString()"
                    (ionChange)="onDateTimeChange($event)"
                    doneText="Übernehmen"
                    cancelText="Abbrechen"
                    color="green"
                    [disabled]="dSS.dienststelle.disabledUstAb"
                  >
                  </ion-datetime>
                  </ng-template>
                </ion-modal>
              </ng-template>
            </ion-modal>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
  </ng-container>

  <ion-row *ngIf="dSS.dienststelle.ustAG">
    <ion-col  >
      <ion-list >
        <ion-item lines="inset">
          <ion-select label="1%-USt. auf den Ausgangsumsatz"
                      labelPlacement="floating"
            *ngIf="!dSS.dienststelle.oneProzentNetto && !isNetto"
            interface="popover"
            [(ngModel)]="dSS.dienststelle.oneProzent"
            (ionChange)="update($event)"
            [disabled]="dSS.dienststelle.disabledOneProzent"
          >
            <ion-select-option
              *ngFor="let option of JaNeinListNumber"
              [value]="option.value"
            >
              {{ option.display }}
            </ion-select-option>
          </ion-select>
          <ion-select *ngIf="dSS.dienststelle.oneProzentNetto || isNetto"
                      interface="popover"
                      [(ngModel)]="dSS.dienststelle.oneProzentNetto"
                      (ionChange)="update($event);isNetto = true;"
                      [disabled]="dSS.dienststelle.disabledOneProzent"
          >
            <ion-select-option
              *ngFor="let option of JaNeinList"
              [value]="option.value"
            >
              {{ option.display }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
      <ion-icon
        class="info_icon_select__position"
        name="information-circle-outline"
        (click)="dSS.showDiv('G')"
      >
      </ion-icon>
      <div *ngIf="dSS.currInfo === 'G'">
        <p class="RIDE-info">
          Erfolgt die Überlassung des Fahrrads aufgrund einer Gehaltsumwandlung,
          handelt es sich für den vorsteuerabzugsberechtigten Arbeitgeber
          umsatzsteuerlich um eine entgeltliche sonstige Leistung i. S. d. § 3
          Abs. 9 UStG. Die Gegenleistung des Beschäftigten besteht in der
          Gehaltsumwandlung in Form des Verzichts auf einen Teil des
          Arbeitslohns. Diese sonstige Leistung ist gemäß § 1 Abs. 1 S. 1 UStG
          umsatzsteuerbar und mangels Anwendbarkeit einer Steuerbefreiung auch
          umsatzsteuerpflichtig. Bei Einstellung "1%-USt. auf den Ausgangsumsatz
          = ja" wird diese Steuerlast bei der Umwandlung berücksichtigt.
        </p>
      </div>
    </ion-col>
  </ion-row>

</ng-container>
  <ion-row class="pt-2" *ngIf="showFairbetrag()">
    <ion-col class="py-0">
      <ion-list class="py-0">
        <ion-item lines="inset">
          <ion-select
            [label]="'Fairbetrag'"
            interface="popover"
            [ngModel]="hasFairbetrag()"
            [disabled]="dSS.dienststelle.disabledFairbetrag"
            (ionChange)="updateFairbetrag($event)"

          >
            <ion-select-option
              *ngFor="let option of JaNeinList"
              [value]="option.value"
            >
              {{ option.display }}
            </ion-select-option>
          </ion-select>
        </ion-item>
        <ion-icon
          class="info_icon_select__position"
          name="information-circle-outline"
          (click)="dSS.showDiv('X')"
        >
        </ion-icon>
      </ion-list>

      <div *ngIf="dSS.currInfo === 'X'">
        <p class="RIDE-info">
          Beim Fairbetrag handelt es sich um eine finanzielle Unterstützung des
          Dienstrad-Leasings seitens Ihres Arbeitsgebers oder Ihrer
          Arbeitgeberin.
        </p>
      </div>
    </ion-col>
  </ion-row>
</ng-container>
